// Menu/filter UI state. Persisted via redux-persist.
//
// Replaces the old `appliedfilters` blob inside reducer.js.

import {
    FILTER_SET_SEARCH,
    FILTER_SET_DIETARY,
    FILTER_SET_SORT,
    FILTER_SET_CATEGORY,
    FILTER_SET_MASTER_CATEGORY,
    FILTER_SET_OPENED_INDEX,
    FILTER_SET_SELECTED_STORE,
    FILTER_RESET,
    FILTERS,
} from '../action-types/menu-actions';
import { CLEAR_STATE_DATA, WEB_LOGOUT } from '../action-types/session-actions';

const initState = {
    selected_store: null,    // { store_id, _id, ... } chosen in multi-store QR
    category: null,          // { type: "MasterCategory" | "category" | "label", obj: {...} }
    selectedMasterCategory: 'All_Item',
    searchQuery: '',
    dietaryFilter: [],       // ["veg", "non-veg"]
    sortBy: '',              // "" | "low" | "high"
    openedIndex: null,       // accordion index
};

const filterReducer = (state = initState, action) => {
    switch (action.type) {
        case FILTER_SET_SELECTED_STORE: {
            // Switching store clears category/search/sort to avoid stale filters.
            return {
                ...state,
                selected_store: action.selected_store,
                category: null,
                selectedMasterCategory: 'All_Item',
                searchQuery: '',
                openedIndex: null,
            };
        }
        case FILTER_SET_CATEGORY: {
            return { ...state, category: action.category };
        }
        case FILTER_SET_MASTER_CATEGORY: {
            return { ...state, selectedMasterCategory: action.selectedMasterCategory };
        }
        case FILTER_SET_SEARCH: {
            return { ...state, searchQuery: action.searchQuery || '' };
        }
        case FILTER_SET_DIETARY: {
            return { ...state, dietaryFilter: action.dietaryFilter || [] };
        }
        case FILTER_SET_SORT: {
            return { ...state, sortBy: action.sortBy || '' };
        }
        case FILTER_SET_OPENED_INDEX: {
            return { ...state, openedIndex: action.openedIndex };
        }
        case FILTER_RESET: {
            return { ...initState, selected_store: state.selected_store };
        }
        case FILTERS: {
            // Compat with the legacy set_filters action that writes the whole blob.
            // Accept partial merges so old call sites keep working.
            const incoming = action.appliedfilters || {};
            return { ...state, ...incoming };
        }
        case WEB_LOGOUT:
        case CLEAR_STATE_DATA: {
            return { ...initState };
        }
        default: {
            return state;
        }
    }
};

export default filterReducer;
